import { takeEvery, fork, put, all, call } from "redux-saga/effects";
import {
  
  DB_MAIN_DATA,
} from "./actionTypes";
import {
  apiError,
  getMainDataSuccessful,
} from "./actions";

import {
  // postAdd,
  getList,
  // getParamsList,
  // postEdit,
  // postDelete,
} from "../../helpers/Helper";
// import swal from "sweetalert";

function* getMainData() {
  try {
    const response = yield call(
      getList,
      "/materialrequest/count/dashboard",
      {}
    );
    yield put(getMainDataSuccessful(response.data));
  } catch (error) {
    yield put(apiError(error));
  }
}
export function* watchgetMainData() {
  yield takeEvery(DB_MAIN_DATA, getMainData);
}
function* DashboardSaga() {
  yield all([
    fork(watchgetMainData),
  ]);
}

export default DashboardSaga;
